import type { RefAttributes } from 'react';

import { Button } from 'antd';
import type { ButtonProps } from 'antd/es/button';

import type { IconName } from '/imports/ui/foundation/Icons';
import { Icon } from '/imports/ui/foundation/Icons';
import { styled } from '/imports/ui/foundation/Theme';

const StyledButton = styled(Button, ({ tokens }) => ({
  display: 'block',
  color: tokens.colorIcon,
  fontSize: 16,
  paddingTop: '0.15em',
  paddingBottom: '0.15em',

  '&:not([disabled])': {
    '&.is-hover, &:hover': {
      background: tokens.colorBgTextHover,
      color: tokens.colorIconHover,
    },
    '&.is-active, &:active': {
      background: tokens.colorBgTextActive,
      color: tokens.colorText,
    },
  },

  '&.type-primary:not([disabled])': {
    background: tokens.colorPrimary,
    color: tokens.colorTextLightSolid,

    '&.is-hover, &:hover': {
      background: tokens.colorPrimaryHover,
      color: tokens.colorTextLightSolid,
    },
    '&.is-active, &:active': {
      background: tokens.colorPrimaryActive,
      color: tokens.colorTextLightSolid,
    },
  },
}));

export interface ActionButtonProps
  extends Omit<ButtonProps, 'icon' | 'shape' | 'title' | 'type'>, RefAttributes<HTMLButtonElement> {
  label: string;
  icon: IconName;
  state?: 'default' | 'hover' | 'active';
  type?: 'default' | 'primary';
}

export const ActionButton = ({
  label,
  icon,
  state = 'default',
  type = 'default',
  ref,
  ...buttonProps
}: ActionButtonProps) => (
  <StyledButton
    key={label}
    {...buttonProps}
    ref={ref}
    className={`is-${state} type-${type}`}
    shape="circle"
    type="text"
    title={label}
    aria-label={label}
    icon={<Icon name={icon} />}
  />
);
